import { render } from "./PostEditor.vue?vue&type=template&id=7538373a&scoped=true"
import script from "./PostEditor.vue?vue&type=script&lang=js"
export * from "./PostEditor.vue?vue&type=script&lang=js"

import "./PostEditor.vue?vue&type=style&index=0&id=7538373a&scoped=true&lang=css"
import "./PostEditor.vue?vue&type=style&index=1&id=7538373a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7538373a"]])

export default __exports__